import { render, staticRenderFns } from "./docsEdit.vue?vue&type=template&id=2643f822&"
import script from "./docsEdit.vue?vue&type=script&lang=js&"
export * from "./docsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports